import './sidebars.css';
import { Link, useLocation } from 'react-router-dom';
import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ReactComponent as ServiceIcon } from '../../assets/service.svg';
import { ReactComponent as ProjectIcon } from '../../assets/project.svg';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useState, useEffect } from 'react';
import { setLogin } from '../../store/app';
import LogOutConfirmation from '../ConfirmationDialog/LogOutConfirmation';
import { TAB_TYPES } from '../../constants';

export function SideBars() {
  const [activeLink, setActiveLink] = useState(TAB_TYPES.Services);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const location = useLocation();
  const onClick = (value) => {
    setActiveLink(value);
  };

  const handleDialog = () => {
    setOpenConfirmationDialog(true);
  };
  useEffect(() => {
    const { pathname } = location;

    if (pathname.includes(TAB_TYPES.Projects)) setActiveLink(TAB_TYPES.Projects);
    else if (pathname.includes(TAB_TYPES.Users)) setActiveLink(TAB_TYPES.Users);
    else if (pathname.includes(TAB_TYPES.Notifications)) setActiveLink(TAB_TYPES.Notifications);
    else if (pathname.includes(TAB_TYPES.Hook)) setActiveLink(TAB_TYPES.Notifications);
  }, [location.pathname]);
  const logout = (issuccess) => {
    setOpenConfirmationDialog(false);
    if (issuccess) {
      localStorage.setItem('monitor-user', '');
      window.location.reload();
      window.client?.store.dispatch(setLogin({ isLoggedin: false }));
    }
  };
  return (
    <div className="Sidebars">
      <div className="includingLogout">
        <div className="completeRows">
          <div className="row">
            <Link to="/dashboard">
              <Tooltip title="Services" placement="right" arrow>
                <div
                  className={activeLink === TAB_TYPES.Services ? 'circularBg' : ''}
                  onClick={() => onClick(TAB_TYPES.Services)}
                >
                  <ServiceIcon />
                </div>
              </Tooltip>
            </Link>
          </div>
          <div className="row">
            <Link to="/dashboard/project">
              <Tooltip title="Projects" placement="right" arrow>
                <div
                  className={activeLink === TAB_TYPES.Projects ? 'circularBg' : ''}
                  onClick={() => onClick(TAB_TYPES.Projects)}
                >
                  <ProjectIcon />
                </div>
              </Tooltip>
            </Link>
          </div>
          <div className="notification">
            <Link to="/dashboard/notifications">
              <Tooltip title="Notifications" placement="right" arrow>
                <div
                  className={activeLink === TAB_TYPES.Notifications ? 'notificationBg' : ''}
                  onClick={() => onClick(TAB_TYPES.Notifications)}
                >
                  <NotificationsNoneOutlinedIcon />
                </div>
              </Tooltip>
            </Link>
          </div>
          <div className="notification">
            <Link to="/dashboard/userlistsettings">
              <Tooltip title="Users" placement="right" arrow>
                <div
                  style={{ color: 'white' }}
                  className={activeLink === TAB_TYPES.Users ? 'circularBg' : ''}
                  onClick={() => onClick(TAB_TYPES.Users)}
                >
                  <SettingsIcon />
                </div>
              </Tooltip>
            </Link>
          </div>
        </div>
        <div className="lowrow" style={{ position: 'relative', bottom: 40 }} onClick={() => handleDialog()}>
          <Tooltip title="Log Out" placement="right" arrow>
            <div>
              <LogoutIcon />
            </div>
          </Tooltip>
        </div>
        {openConfirmationDialog && <LogOutConfirmation closedialogs={logout} />}
      </div>
    </div>
  );
}
